export const SignupFooter = {
  bindings: {
    text: '<',
  },

  template: `
    <ol class="signup-footer pt-5 px-5 mb-0 text-white">
      <li class="small" ng-show="$ctrl.text.firstPaymentInDays == 0">
        Your card will be charged immediately.
      </li>
      <li class="small" ng-show="$ctrl.text.firstPaymentInDays > 0">
        Your card will be charged {{ $ctrl.text.firstPaymentInDays }} days. If
        you cancel before then you won't be charged.
      </li>
      <li class="small">
        Currency of transaction is Australian Dollars (AUD).
      </li>
      <li class="small">
        12WBT Trading Pty Ltd. is an Australian owned business located in
        Australia (ABN - 31 154 009 622). Address: PO Box 1055, Darlinghurst
        NSW 1300
      </li>
      <li class="small">
        When purchasing from 12WBT Trading Pty Ltd. your financial details are
        passed through a secure server using the latest 256-bit SSL (secure
        sockets layer) encryption technology. If you have any questions
        regarding our security policy, please contact our customer service
        support centre which is <a href="mailto:support@voome.com.au" class="text-white">
        support@voome.com.au</a>.
      </li>
    </ol>`,
};



// WEBPACK FOOTER //
// ./src/components/Signup/SignupFooter.js